import React from 'react'
import { Link } from 'react-router-dom'
import abimg from '../../images/about/img-1.jpg'
import abimg4 from '../../images/shape/shape2.png'
import './style.css'

const About = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="about-area">
            <div className="container">
                <div className="row">

                    {/* Image Section */}
                    <div className="col-lg-5 col-md-12 grid col-12">
                        <div className="about-cercle">
                            <div className="about-img">
                                <img
                                    src={abimg}
                                    alt="Nardhanamala Centre for Performing Arts"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Text Section */}
                    <div className="col-lg-6 offset-lg-1 grid col-md-12 col-12 mt-8">
                        <div className="about-text">
                            <div className="section-title">
                                <div className="thumb-text">
                                    <span>ABOUT US</span>
                                </div>

                                <h2>
                                    <span style={{ letterSpacing: '1px' }}>
                                        NARDHANAMALA
                                    </span>
                                    <br />
                                    <small style={{ fontWeight: '500' }}>
                                        CENTRE FOR PERFORMING ARTS FOUNDATION
                                    </small>
                                    <br />
                                    <span>
                                        Arts Accessible, Structured & Beneficial for All Ages
                                    </span>
                                </h2>
                            </div>

                            <p>
                                Founded in 1992 and formally established in 2018,
                                <strong> Nardhanamala Centre for Performing Arts </strong>
                                is rooted in over three decades of dedicated teaching,
                                performance, and community outreach in Indian performing arts.
                            </p>

                            <p>
                                Registered under the Ministry of Art and Culture,
                                the organization functions through a dual structure
                                that strengthens both social impact and operational sustainability.
                            </p>

                            <ul>
                                <li>
                                    <strong>Nardhanamala NGO / Trust</strong>
                                    <br />
                                    <small>Registration No: TN/2025/0607013</small>
                                </li>
                                <li>
                                    <strong>Nardhanamala Private Limited Company</strong>
                                    <br />
                                    <small>Company No: 179423</small>
                                </li>
                            </ul>

                            <p>
                                This integrated model allows us to deliver inclusive,
                                high-quality arts education while creating long-term
                                career pathways and meaningful engagement across
                                diverse communities.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative Shape */}
            <div className="ab-shape">
                <img src={abimg4} alt="" />
            </div>
        </div>
    )
}

export default About
